 <template>
	<div id="userfocus" class=""> 
		<leftnav class="fl" mkcode="F" itemcode="F-GZLY"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''" >
			<govheader></govheader>
			<div class="index_left_centerpage"> 
			<div class="whitebox right_topbox" v-if="userdata.token">
				<div class="right_boxtitle">
					<span class="fl right_title">关注领域</span>
					<el-tooltip    effect="light"  placement="top-start"  >
						<i class="el-icon-question" style="color:cornflowerblue;margin-left: 5px; "></i><div slot="content" class="list_tips">概念添加上限为80个左右，如遇上限，可适当删除旧概念，再进行新增</div>
						</el-tooltip>
					<span class="fr userfocus_save" @click="getchoosevalue('save')">保存</span>
					<video-teaching :type="6" seat="top"></video-teaching>
				</div> 
					<table border="0" cellspacing="0" cellpadding="0" >
						<tr>
							<td class="selected_concept"><span>已选概念</span></td>
							<td><span class="basefont selected_tag" v-for="item in notionlistdefault">{{item.label}}<i @click="ckll(item.value)" class="concept_notionlist el-icon-close" ></i></span></td>
							<td><span class="concept_empty fr" @click="empty()">清空</span></td>
						</tr>
					</table> 
					<div class="unl-list userfoucs_cylist" v-for="(list,a) in allnotionlist" v-show="list.label.indexOf('未来')<0">
						<h4 class="title">{{list.label}}
						<span class="fr userfocus_flod"  @click="flodnum=!flodnum;foldfun($event)" >收起</span> </h4> 
						<div class="eeee">
							<div   v-for="(list1,i) in list.children" v-if="list1.label!='环保'"><h4 class="title2"><input type="checkbox" v-model="list1.ischecked" @change="getchoosevalue()">{{list1.label}}<span class="fr userfocus_flod2"  @click="foldfun($event)" >收起</span> </h4>
							<div class="aaa" style="width: 98%;">
									<dl class="userfoucs_cyname" style="padding-left: 30px;" v-for="item in list1.children">
										<dt class="fl"><input type="checkbox" v-model="item.ischecked" @change="getchoosevalue()">{{item.label}}</dt>
										<dd class="fl"><span v-for="item1 in item.children"><input type="checkbox"  v-model="item1.ischecked" @change="getchoosevalue()">{{item1.label}}</span></dd> 
									</dl>
									</div> 
							</div> 
							</div>  
						</div> 
			</div> 
			<div v-else>
				<div class="heightVh95 whitebox container-flex-center">
					<freeUserTips :type="4" :bgtype="0"></freeUserTips>
				</div> 
			</div>
			</div>
			</div>
		</div>
</template> 
<script>
import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
	  name: 'userFocus',
	  computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	  data(){return{
				userdata:{},
				title:'用户中心-关注领域',
				showfixednotion:false,
				notionlistdefault:[],
				notionguide:[{name:'先进制造业',children:[]},{name:'传统制造业',children:[]},{name:'未来产业',children:[]},], 
				allnotionlist:[],
				flodnum:false, 
				indexnum:1,
				choosenotionlength:20,
				 
			}}, 
		 created() {
		 	this.userdata=this.getuseriformation();
		 },
			mounted() {
				this.getdefaultNotion(this.userdata.notionText,this.userdata.notion);
				if(this.userdata.token){
					this.getallnotionlist();
				}
			},
			methods:{   
				// ckfun(a){
				// 	// this.flodnum = !this.flodnum;
				// 	if(this.flodnum){
				// 		console.log(a); 
				// 		console.log('11',document.getElementsByClassName('eeee'))
				// 		document.getElementsByClassName('eeee')[a].className="eeee ccc"; 
				// 		document.getElementsByClassName('userfocus_flod')[a].innerHTML="展开"
				// 	}else{
				// 		console.log(a); 
				// 		console.log('23',document.getElementsByClassName('eeee'))
				// 		document.getElementsByClassName('eeee')[a].classList.remove('ccc'); 
				// 		document.getElementsByClassName('userfocus_flod')[a].innerHTML="收起"
				// 	}
					
				// },
			 //收起和展开
				
				foldfun(e){
					// console.log(e.target);  //当前节点
					// console.log(e.currentTarget.parentElement); 
					var parent=e.currentTarget.parentElement;  //当前节点的父节点
					var thathtml=e.target.innerHTML;
					console.log(thathtml);
					if(thathtml=='展开'){
						$(parent).nextAll().css({'display':"block"}); //拿到点击的节点的父节点，然后将其底下的子节点做显示和隐藏
						e.target.innerHTML='收起';
					}else{
					$(parent).nextAll().css({'display':"none"});
					e.target.innerHTML='展开';
					}
				},
				
				//获取用户原始概念数据
				getdefaultNotion(labeltext,valuetext){
					//用户概念数据 
					console.log('用户概念数据',labeltext,valuetext)
					var notionfont=labeltext.split(',');
					var notioncode=valuetext.split(',');  
					var datd=[];
					console.log(notioncode);
					for(var i=0;i<notioncode.length;i++){   
						datd.push({label:notionfont[i],value:notioncode[i]});  
					} 
					console.log('datad',datd);
					this.notionlistdefault=datd;
					// this.getpagenotionlist(datd); 
				}, 
				getpagenotionlist(data){
					// console.log('data111',data);
				 this.notionguide[0].children=data.filter(data=>{
						return data.value.indexOf('A')==0;
					});
					this.notionguide[1].children=data.filter(data=>{
						return data.value.indexOf('B')==0;
					})
					this.notionguide[2].children=data.filter(data=>{
						return data.value.indexOf('C')==0;
					});
					// console.log('this.notionguide',this.notionguide);
				},
				//将概念数据分类
				getallnotionlist(){
					//三大产业概念数据
					var _this=this;
					this.$axios.get(this.$api.tag.notion.list()+'?level=4',{headers:{AuthToken:this.userdata.token}}).then(function(res){
						// console.log(res.data)
						if(res.data.success){  
							var deallnotionlist=res.data.list;
							// console.log('res',res.data.list)
							_this.allnotionlist=_this.turnchecked(res.data.list);   
							// console.log(111111,deallnotionlist);  
							_this.allnotionlist = _this.swapArr(_this.allnotionlist,1,2);
							// _this.allnotionlist[2]= res.data.list[1];
							// _this.notionlist=res.data.list;  
						}else{ 
							
						} 
					}).catch(function (error) { 
						// 请求失败处理 console.log(error);
					});
				},
				 swapArr(arr, index1, index2) { //调换数组元素位置
				arr[index1] = arr.splice(index2, 1, arr[index1])[0];
				return arr
				},
				//将所有概念列表进行check赋值
				turnchecked(datat){  
					var defaultnotionlist=this.notionlistdefault;
					
					// for(var i=0;i<datat.length;i++){ 
					// 	var datai=datat[i]; 
					// 	for(var d=0;d<datai.children.length;d++){ 
					// 		var datad=datai.children[d];
					// 		datad.ischecked=false;
					// 		for(var x=0;x<defaultnotionlist.length;x++){
					// 			if(datad.value == defaultnotionlist[x].value){
					// 				datad.ischecked=true;
					// 			}
					// 		} 
					// 		for(var s=0;s<datad.children.length;s++){ 
					// 			var datas=datad.children[s];
					// 			datas.ischecked=false;
					// 			for(var x=0;x<defaultnotionlist.length;x++){
					// 				if(datas.value == defaultnotionlist[x].value){
					// 					datas.ischecked=true;
					// 				}
					// 			} 
					// 		}
					// 	}
					// }
					//递归函数 反复执行传值
					
					for(var i=0;i<datat.length;i++){
						let aary2=datat[i].children;
						datat[i].ischecked=false;
						if(aary2){ 
							 const fn = (source)=>{
							  source.forEach(el=>{
										el.ischecked=false;
										for(var i=0;i<defaultnotionlist.length;i++){
											if(defaultnotionlist[i].value == el.value){
												// console.log('112112',el);
												el.ischecked=true;
											}
										} 
							   el.children && el.children.length>0 ? fn(el.children) : ""
							  })
							 };
							 fn(aary2); 
						}
					} 
					// console.log('turncheckeddata',datat);
					return datat;
				},   
				//点x删除
				ckll(value){ 
					console.log(value,this.notionlistdefault);
					var datat=this.notionlistdefault,ndata=[];
					for(var i =0;i<datat.length;i++){
						if(datat[i].value !=value){
							ndata.push(datat[i]);
						}
					} 
					this.notionlistdefault = ndata;
					this.turnchecked(this.allnotionlist);
					console.log('ndata',ndata,);
				},
				addnotinfun(){
					
				},
				//清空
				empty(){
					this.notionlistdefault =[];
					this.turnchecked(this.allnotionlist);
				},
				//点击确认后拿取数据
				getchoosevalue(type){
					console.log(this.choosenotionlength)
					if(this.choosenotionlength>586){
						// alert('概念个数超过上限');
						this.$message({
							type: 'warning',
							message: '概念个数超过上限',
						});
						return;
					}; 
					console.log('11321312',this.allnotionlist);
					var datat=this.allnotionlist;
					var ischeckdata=[],notionchooselabel1="",notionchoosevalue1=""; 
					for(var i=0;i<datat.length;i++){
						let aary2=datat[i].children; 
						if(aary2){ 
							 const fn = (source)=>{
							  source.forEach(el=>{ 
										if(el.ischecked){ 
											ischeckdata.push({label:el.label,value:el.value}); 
											notionchooselabel1=notionchooselabel1+el.label+","; 
											notionchoosevalue1=notionchoosevalue1+el.value+",";
											this.choosenotionlength=notionchoosevalue1.length;
										} 
							   el.children && el.children.length>0 ? fn(el.children) : ""
							  })
							 }; 
									fn(aary2); 
								
						}
					}
				
					var ajaxnotiontext= notionchoosevalue1.substring(0,notionchoosevalue1.length-1);
					var ajaxurl=this.$api.cyl.usercenter.updatenotion();
					var _this=this;
						console.log('aakjkj',ischeckdata,ajaxnotiontext);
						if(type == 'save'){
							$.ajax({
								type:"POST",
								url:ajaxurl,
								data:{notionList:ajaxnotiontext},
								headers:{AuthToken:this.userdata.token },
								success:function(res){ 
									console.log(res); 
									if(res.success){
										 //存储本地信息
										 _this.userdata.notion=res.data.notionCode;
										 _this.userdata.notionText=res.data.notion;
										 _this.setlocalmessage(_this.userdata);
											//成功后变换数组内容
											_this.getdefaultNotion(res.data.notion,res.data.notionCode);
											// _this.notionlistdefault=ischeckdata;
											_this.showfixednotion=false;
											if(type=='save'){
												// alert('保存成功');
												_this.$message({
													type: 'success',
													message: '保存成功',
												});
											}
											// _this.getpagenotionlist(ischeckdata);  
									} 
								} 
							});
						} 
				},
				setlocalmessage(datasm){ 
					if (typeof datasm === 'object') {
							datasm = JSON.stringify(datasm); 
					}    
					localStorage.setItem('userData', datasm); 
					sessionStorage.setItem('userData', datasm);  
				}
				
			}
	}  
</script>

<style>
	
</style>



